module.exports = __webpack_public_path__ + "static/media/Intersection 18.856878d4.png";